import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet} from '../../../../components/shared/hoc/createAdminPage'
import {OptionalChip, StyledTableCaption, TableRowName} from '../../../../styledComponents/adminPage/Table'
import {Box, Table, TableBody, TableRow, TableCell} from '@mui/material'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {Nullable} from '../../../../app/TypeHelpers'
import {AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import {NatPostAdminDisasterRegisterParams} from '../repository/NatPostAdminDisasterRegister'
import {NatPutAdminDisasterEditParams} from '../repository/NatPutAdminDisasterTopicEdit'
import {DISASTER_TOPIC_CATEGORY} from '../../../../CodeMaster'
import {FormLabelContainer} from '../../applications/common/admin/NatAdminApplicationCommon'

interface Props {
    mode: 'register' | 'edit'
    condominiumName: Nullable<string>
    category: DISASTER_TOPIC_CATEGORY
    title?: string
    description?: Nullable<string>
    version?: number
    eventEmitter: EventEmitterExAdmin
    onRegisterTopic?: (registerParam: NatPostAdminDisasterRegisterParams) => Promise<void>
    onEditorTopic?: (editParam: NatPutAdminDisasterEditParams) => Promise<void>
    backButtonText: string
    onBack: () => void
}

interface States {
    title: string
    description: string
}

export class NatAdminDisasterTopicForm extends Component<Props, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.state = {
            title: this.props.title ? this.props.title : '',
            description: this.props.description ? this.props.description : '',
        }

        this.handleChangeTitle = this.handleChangeTitle.bind(this)
        this.handleChangeDescription = this.handleChangeDescription.bind(this)
        this.onClickRegisterButton = this.onClickRegisterButton.bind(this)
    }

    handleChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({title: event.target.value})
    }

    handleChangeDescription(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        this.setState({description: event.target.value as string})
    }

    async onClickRegisterButton(): Promise<void> {
        const {title, description} = this.state

        if (this.props.mode === 'register') {
            const registerParam: NatPostAdminDisasterRegisterParams = {
                title: title,
                category: this.props.category.value,
                description: description ?? null
            }
            await this.props.onRegisterTopic?.(registerParam)
        } else if (this.props.mode === 'edit') {
            const editParam: NatPutAdminDisasterEditParams = {
                title: title,
                category: this.props.category.value,
                description: description ?? null,
                version: this.props.version ? this.props.version : 0
            }
            await this.props.onEditorTopic?.(editParam)
        }
    }

    renderInputFormTable(): ReactNode {
        const {condominiumName, category, eventEmitter} = this.props
        const {title, description} = this.state

        return (
            <Table>
                <StyledTableCaption>トピック情報</StyledTableCaption>
                <TableBody>
                    {condominiumName &&

                        <TableRow>
                            <TableRowName>物件名</TableRowName>
                            <TableCell>
                                {condominiumName}
                            </TableCell>
                        </TableRow>
                    }
                    <TableRow>
                        <TableRowName>カテゴリ</TableRowName>
                        <TableCell>
                            {category.label}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>タイトル</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50
                                    }
                                }}
                                required
                                fullWidth
                                value={title}
                                onChange={this.handleChangeTitle}
                                placeholder={'50文字以内'}
                                eventKeys={['title']}
                                eventEmitter={eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <FormLabelContainer>
                                説明文
                                <Box ml={'32px'}><OptionalChip label={'任意'}/></Box>
                            </FormLabelContainer>
                            <Box mb={'16px'}/>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 200,
                                        minRows: 5
                                    }
                                }}
                                value={description}
                                fullWidth
                                multiline
                                onChange={this.handleChangeDescription}
                                placeholder={'このトピックに投稿してほしい内容を記載することができます。（200文字以内）'}
                                eventKeys={['description']}
                                eventEmitter={eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={!(this.state.title)}
                        onClick={this.onClickRegisterButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.props.onBack}
                    >
                        {this.props.backButtonText}
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): ReactElement {
        return (
            <>
                <PageMainArea>
                    {this.renderInputFormTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}